import React from "react";
import AdminLayout from "../../admin/layouts/AdminLayout";
import Breadcrumb from "../../admin/breadcrumb/Breadcrumb";

const LayoutTemplate = ({
  children,
  mainTitle = "",
  subTitle = "",
  mainCSSIdentifier = "",
}) => {
  return (
    <AdminLayout>
      <div className="content-col">
        <Breadcrumb mainTitle={mainTitle} title={subTitle} />
        <div
          className={`container-fluid inner-content py-4 ${mainCSSIdentifier}`}
        >
          {children}
        </div>
      </div>
    </AdminLayout>
  );
};

export default LayoutTemplate;
